import * as React from 'react';

import partnershipsLogo from 'images/ent-website/partnerships-logo.svg';

function PartnershipLogo() {
  return <img src={partnershipsLogo} width={240} alt="Coursera Partnerships" />;
}

export default PartnershipLogo;
